import { render, staticRenderFns } from "./SupportNetwork.vue?vue&type=template&id=79d4ab87&scoped=true"
import script from "./SupportNetwork.vue?vue&type=script&lang=ts"
export * from "./SupportNetwork.vue?vue&type=script&lang=ts"
import style0 from "./SupportNetwork.vue?vue&type=style&index=0&id=79d4ab87&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79d4ab87",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('79d4ab87')) {
      api.createRecord('79d4ab87', component.options)
    } else {
      api.reload('79d4ab87', component.options)
    }
    module.hot.accept("./SupportNetwork.vue?vue&type=template&id=79d4ab87&scoped=true", function () {
      api.rerender('79d4ab87', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/clients/ClientRightSide/SupportNetwork.vue"
export default component.exports